import { createContext } from "react";
const VisitContext = createContext();
export default VisitContext;